import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconMenuLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.25 17.634a.725.725 0 0 1-.534-.215.725.725 0 0 1-.216-.535c0-.212.072-.39.216-.534a.726.726 0 0 1 .534-.215h15.5c.212 0 .39.072.534.215a.726.726 0 0 1 .216.535c0 .212-.072.39-.216.534a.726.726 0 0 1-.534.215H4.25Zm0-4.884a.725.725 0 0 1-.534-.216A.726.726 0 0 1 3.5 12c0-.213.072-.391.216-.534a.725.725 0 0 1 .534-.216h15.5c.212 0 .39.072.534.216A.726.726 0 0 1 20.5 12a.722.722 0 0 1-.216.534.726.726 0 0 1-.534.216H4.25Zm0-4.885a.725.725 0 0 1-.534-.215.726.726 0 0 1-.216-.535c0-.213.072-.39.216-.534a.726.726 0 0 1 .534-.216h15.5c.212 0 .39.072.534.216a.725.725 0 0 1 .216.535c0 .212-.072.39-.216.534a.726.726 0 0 1-.534.215H4.25Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconMenuLine;
